import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.699 6V.9q0-.382.258-.64A.86.86 0 0 1 3.595 0a.88.88 0 0 1 .642.26A.86.86 0 0 1 4.5.9V6h.9V.9q0-.382.257-.64A.86.86 0 0 1 6.294 0a.88.88 0 0 1 .643.26A.86.86 0 0 1 7.2.9V6q0 1.27-.763 2.223A3.55 3.55 0 0 1 4.5 9.475V18.3a.87.87 0 0 1-.257.642.86.86 0 0 1-.638.258.88.88 0 0 1-.643-.258.86.86 0 0 1-.262-.642V9.475A3.54 3.54 0 0 1 .762 8.223Q0 7.271 0 6V.9Q0 .518.257.26A.86.86 0 0 1 .895 0a.88.88 0 0 1 .642.26A.86.86 0 0 1 1.8.9V6zm9.9 4.8h-2.1a.87.87 0 0 1-.64-.258.87.87 0 0 1-.26-.642V4.8q0-2.025 1.1-3.412T13.425 0q.417 0 .696.313.279.314.279.737V18.3a.87.87 0 0 1-.258.642.86.86 0 0 1-.637.258.88.88 0 0 1-.643-.258.86.86 0 0 1-.262-.642z"
    }, null, -1)
  ]))]))
}
export default { render: render }